'use client';

import { createZustandStore } from '../../../zustand';

import { onClearDealsFilterStoreCallback } from './callbacks';
import { IDealsFilterState } from './types';

/**
 * This creates a local global deal filter state tracker and update the filter
 * values.
 */
export const useDealsFilterStore = createZustandStore<IDealsFilterState>()(
  (set) => ({
    searchKey: '',
    dateRange: null,
    searchTypeFilter: { label: 'dealListScreen.dealId', value: 'dealId' },
    onUpdateDealsSearchKey: (searchText) =>
      set(() => ({ searchKey: searchText })),
    onUpdateDealsDateRange: (dateRange) => set(() => ({ dateRange })),
    selectedDealsFilters: [],
    updateSelectedFilters: (filters) =>
      set(() => ({ selectedDealsFilters: filters })),
    onUpdateSearchTypeFilter: (searchTypeFilter) =>
      set(() => ({ searchTypeFilter })),
    selectedCategory: null,
    onUpdateSelectedCategory: (category) =>
      set(() => ({ selectedCategory: category })),
    selectedBrands: [],
    onUpdateSelectedBrands: (brands) => set(() => ({ selectedBrands: brands })),
    selectedAssetGroups: [],
    onUpdateSelectedAssetGroups: (assetGroups) =>
      set(() => ({ selectedAssetGroups: assetGroups })),
    sortBy: null,
    updateSortBy: (sortBy) => set(() => ({ sortBy })),
    orderBy: null,
    updateOrderBy: (orderBy) => set(() => ({ orderBy })),
    dealsListTableColumnVisibility: {},
    updateDealsListTableColumnVisibility: (visibility) =>
      set(() => ({ dealsListTableColumnVisibility: visibility })),
    dealsListTablePageSize: 20,
    updateDealsListTablePageSize: (pageSize) =>
      set(() => ({ dealsListTablePageSize: pageSize })),
    isFiltersDialogVisible: false,
    onUpdateIsFiltersDialogVisible: (visible) =>
      set(() => ({ isFiltersDialogVisible: visible })),
    isFiltersDialogPinned: false,
    onUpdateIsFiltersDialogPinned: (pinned) =>
      set(() => ({ isFiltersDialogPinned: pinned })),
    filterSidebarWidth: 384,
    updateFilterSidebarWidth: (width) =>
      set(() => ({ filterSidebarWidth: width })),
    clearDealsStore: onClearDealsFilterStoreCallback(set),
  })
);
